import { BrandedEmailsSettingsRepository } from '@packlink/packlink-sdk';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@sdk';

export const BRANDED_EMAILS_SETTINGS_CACHE_KEY = 'branded-emails-settings';
const brandedEmailsSettingsRepository = new BrandedEmailsSettingsRepository(apiClient);

export const useBrandedEmailsSettings = (subscribed: boolean) => {
    const {
        data: brandedEmails,
        isLoading,
        isRefetching,
    } = useQuery({
        queryKey: [BRANDED_EMAILS_SETTINGS_CACHE_KEY],
        queryFn: () => brandedEmailsSettingsRepository.getBrandedEmailsSettings(),
        enabled: subscribed,
    });

    return {
        brandedEmails,
        isLoading,
        isRefetching,
    };
};
